<template>
  <layout> </layout>
</template>

<script>
import Layout from './components/content/Layout/Layout.vue'

import { mapActions } from 'vuex'

export default {
  name: 'App',
  components: { Layout },
  created() {
    if (localStorage.getItem('token')) {
      this.fetchProfileData()
    }
  },
  methods: {
    ...mapActions('authentication', ['fetchUserInformations', 'fetchProjectId', 'fetchStartDateOfProject', 'fetchProjectName']),
    async fetchProfileData() {
      await this.fetchUserInformations()
      await this.fetchProjectId()
      await this.fetchStartDateOfProject()
      await this.fetchProjectName()
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.main-color {
  color: #8b69a9;
}

.font-bold {
  font-weight: bold;
}
</style>
